import { render, staticRenderFns } from "./Spiritpet.vue?vue&type=template&id=75fc7f60&scoped=true"
import script from "./Spiritpet.vue?vue&type=script&lang=js"
export * from "./Spiritpet.vue?vue&type=script&lang=js"
import style0 from "./Spiritpet.vue?vue&type=style&index=0&id=75fc7f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fc7f60",
  null
  
)

export default component.exports